/**
 * Wegic 地址
 */
export const WEGIC_URL = 'https://wegic.ai';